var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{ref:"logo",staticClass:"o-logo",attrs:{"to":"/"}},[_c('span',{ref:"logoSymbol",staticClass:"o-logo__lottie",class:_vm.className + ' ' + _vm.containerClass}),_c('icon',{attrs:{"icon":"solia-logo-without-symbol"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }